import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { TableTarifComponent } from '../table-tarif/table-tarif.component';
import { SliderHomeComponent } from '../slider-home/slider-home.component';
import { ListPricesComponent } from '../list-prices/list-prices.component';
import { User } from '../user/user';

import { ContactComponent } from '../contact/contact.component';
import { PartnersComponent } from '../partners/partners.component';
import { BackgroundAnimationComponent } from '../background-animation/background-animation.component';
import { SeoService } from '../services/seo.service';

@Component({
  selector: 'app-main',
  imports: [
    TableTarifComponent,
    ContactComponent,
    PartnersComponent,
    SliderHomeComponent,
    ListPricesComponent,
    BackgroundAnimationComponent,
  ],
  standalone: true,
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent implements OnInit, OnDestroy {
  user!: User;
  currencyEUR!: boolean; 
  isDayMode = true;
  isBrowser: boolean;
  private langChangeSub?: Subscription;

  constructor(
    private seo: SeoService,
    private translate: TranslateService,
    @Inject(PLATFORM_ID) platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.applyHomeSeo();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => this.applyHomeSeo());
  }

  ngOnDestroy(): void {
    this.langChangeSub?.unsubscribe();
  }

  private applyHomeSeo(): void {
    const lang = this.translate.currentLang || this.translate.defaultLang || 'cs';
    this.seo.updateHomeTags(lang);
  }
}
